import { useState, useEffect } from "react";

const AddSubGenres = ({ setAltGenres, currentGenres }) => {
  const initializeSubGenres = () => {
    const subGenres = [];
    for (let i = 0; i < 3; i++) {
      if (currentGenres[i]) {
        subGenres.push({ id: i, value: currentGenres[i].name });
      } else {
        // Add empty genre field if currentGenres has fewer than 3
        subGenres.push({ id: i + 1, value: "" });
      }
    }
    return subGenres;
  };

  const [subGenres, setSubGenres] = useState(initializeSubGenres);

  // Update alt genres whenever subGenres changes
  useEffect(() => {
    setAltGenres(subGenres);
  }, [subGenres, setAltGenres]);

  const handleInputChange = (id, newValue) => {
    setSubGenres((prevSubGenres) =>
      prevSubGenres.map((subGenre) =>
        subGenre.id === id ? { ...subGenre, value: newValue } : subGenre
      )
    );
  };

  return (
    <>
      <div className="">
        <h3 className="label-text label">Lägg till genres</h3>
        {subGenres.map((subGenre) => (
          <div key={subGenre.id} className="mb-2">
            <input
              type="text"
              value={subGenre.value}
              onChange={(e) => handleInputChange(subGenre.id, e.target.value)}
              className="input input-bordered w-full max-w-xs"
              placeholder={`Genre #${subGenre.id}`}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default AddSubGenres;
